<template>
  <!-- todo: when in use, replace for mdi-alternative icon -->
  <svg
    class="crv-shopping-cart-solid crv-svg-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="6 5 22 22"
  >
    <path
      fill-rule="evenodd"
      d="M23.1278157,18.5621641 L24.2357769,13.6871641 C24.3157691,13.3351797 24.04823,13 23.687269,13 L14.4814385,13 L14.2666103,11.9497656 C14.213079,11.6879922 13.9827352,11.5 13.7155242,11.5 L11.3125001,11.5 C11.001836,11.5 10.75,11.7518359 10.75,12.0625 L10.75,12.4375 C10.75,12.7481641 11.001836,13 11.3125001,13 L12.9503834,13 L14.5968213,21.0492578 C14.2029306,21.2757813 13.9375008,21.7005156 13.9375008,22.1875 C13.9375008,22.912375 14.525126,23.5 15.25,23.5 C15.9748763,23.5 16.5625015,22.912375 16.5625015,22.1875 C16.5625015,21.8201406 16.4113999,21.4882422 16.1681889,21.25 L21.0817917,21.25 C20.8386042,21.4882422 20.6875026,21.8201406 20.6875026,22.1875 C20.6875026,22.912375 21.2751277,23.5 22.0000029,23.5 C22.7248781,23.5 23.3125032,22.912375 23.3125032,22.1875 C23.3125032,21.6678438 23.0104407,21.2187812 22.5723702,21.0061328 L22.701675,20.4371641 C22.7816672,20.0851797 22.514128,19.75 22.153167,19.75 L15.8621185,19.75 L15.70872,19 L22.5793077,19 C22.8419484,19 23.0696204,18.8182656 23.1278157,18.5621641 Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'CrvShoppingCartSolid',
}
</script>